/**
 * @generated SignedSource<<88cf3bfc29c34f6f4a87d27aec108067>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionAboutSectionContentfulRelayFragment$data = {
  readonly aboutThisCollection: string | null | undefined;
  readonly aboutThisCollectionHeader: string | null | undefined;
  readonly aboutThisCollectionImage: {
    readonly name: string | null | undefined;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly collectionNameExternal: string | null | undefined;
  readonly " $fragmentType": "collectionAboutSectionContentfulRelayFragment";
};
export type collectionAboutSectionContentfulRelayFragment$key = {
  readonly " $data"?: collectionAboutSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionAboutSectionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionAboutSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collectionNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutThisCollectionHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutThisCollection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "aboutThisCollectionImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": "name",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TemplateCollection",
  "abstractKey": null
};

(node as any).hash = "33b71e01173f5038aa6d6f4435ea2c8a";

export default node;
